/* Use to add JS functions common on desktop and mobile to avoid duplicates */

// Function get blog articles
function getBlogArticles(id, type, nbArticlesToShow) {
    // Default blog title and description
    let title = Translator.translate('blog_texte_h1');
    let texteSeo = Translator.translate('blog_texte_seo');

    // Change title and description of blog
    if (type == 'cms_subcategory') {
        title = $('#blog_title_' + id).text();
        texteSeo = $('#blog_texte_seo_' + id).text();
    }

    // Change title and description of blog on li click
    $('#cms').find('h1.title').html(title);
    $('#blog_texte_seo').html(texteSeo);

    // Remove/add selected class
    $('.blog-rubriques li').removeClass("selected");
    $(this).addClass("selected");

    //Close filter popup
    $("#cms_subcategory_menu .cms_menu_item.filter").removeClass("open");

    //Reset filters
    $("#date_filter_wrapper li.years").each(function () {
        let elmt = $(this).find("input[type=checkbox]");

        if ($(elmt).is(':checked')) {
            $(elmt).trigger('click');
        }

    });

    // Load cms articles
    ajaxLoadCp(id, type, nbArticlesToShow);
}

/**
 * Function load cms page
 * @param {*} id - CMS caegory ID
 * @param {*} type - Type of CMS : cms_category or cms_subcategory
 * @param {*} nbArticlesToShow - Number of articles to display by default
 */

function ajaxLoadCp(id, type, nbArticlesToShow) {
    $.ajax({
        type: 'post',
        url: path_relative_root + 'ajax_get_list_cms_page.php',
        data: 'type=' + type + '&id=' + id,
        success: function (result) {
            result = JSON.parse(result);

            // génération des prévisu cms page
            if (result.success) {
                $('#cms_subcategory_menu .item.selected').removeClass('selected');
                if (type == "cms_category") {
                    $('#cms_subcategory_menu .see_all').addClass('selected');
                } else {
                    $('#cms_subcategory_menu .see_all').show();
                    $('#csc_menu_' + id).addClass('selected');
                }

                $('#content_previsu_cms_page').remove();
                $('#cms_subcategory_menu item').removeClass('selected');
                $('#cms_subcategory_menu item.see_all').show();
                $('#btnSeeMore').remove();
                $('#cms').append(result.html);
                $('#cms').append('<span class="see_more_txt_cta button primary" id="btnSeeMore" data-categ-id="' + id + '" data-type="' + type + '" data-articles-to-show="' + nbArticlesToShow + '" onClick="seeMoreArticles(this)">' + Translator.translate('see_more') + '</span>');

                // show x articles on page load
                $('#content_previsu_cms_page .previsu_cms_page').hide();
                $('#content_previsu_cms_page .previsu_cms_page:nth-child(n+1):nth-child(-n+' + nbArticlesToShow + ')').show();

                let cmsSubcategory = $('body.cms_subcategory');
                let cmsCategory = $('body.cms_category');
                let cmsElement = $('#cms');

                if (cmsSubcategory.length || cmsCategory.length) {
                    setTimeout(function () {
                        cmsElement.addClass('visible');
                    }, 150);
                }
            }
        },
        complete: function () {
            nbArticlesToShow = $("#content_previsu_cms_page .previsu_cms_page:visible").length;
            let nbArticles = $('#content_previsu_cms_page .previsu_cms_page').length;

            updateTotalElements(nbArticlesToShow, nbArticles);
        }
    });
}

// Update elements counter and show/hide see more button
function updateTotalElements(nbArticlesToShow, nbArticles) {
    let seeMore = $('#cms .see_more_txt_cta');
    let translatedTexteArticle = (nbArticles > 1) ? 'articles' : 'article';

    if (nbArticles <= nbArticlesToShow) {
        seeMore.hide();
    } else {
        seeMore.show();
    }

    $('#nb_article').html(nbArticles + ' ' + Translator.translate(translatedTexteArticle));
}

// Get selected month
function selectAllMonths(obj, year) {
    $('#date_filter_wrapper input[year=' + year + ']').parent().parent().toggle();

    if ($(obj).is(':checked')) {
        $('#date_filter_wrapper input[year=' + year + ']:not(":checked")').trigger('click');
    } else {
        $('#date_filter_wrapper input[year=' + year + ']:checked').trigger('click');
    }
}

// Filter articles
function filterPosts(elmt) {
    let articlesToShowOnFilter = $('#content_previsu_cms_page .previsu_cms_page[hide=false]').length;
    let nbArticlesToShow = $("#cms_element_per_line").val();
    let year = $(elmt).attr('year');

    $('#content_previsu_cms_page .previsu_cms_page').attr('hide', 'true');
    $('#content_previsu_cms_page .previsu_cms_page').css('display', 'none');

    let checkedFilters = $('#date_filter_wrapper input[type=checkbox][name="dates[]"]:checked');

    if (checkedFilters.length) {
        checkedFilters.each(function () {
            let value = $(this).val();

            if (value.length == 7) {
                $('#content_previsu_cms_page .previsu_cms_page.posts_' + value).attr('hide', 'false');
                $('#content_previsu_cms_page .previsu_cms_page').css('display', 'block');

                if ($('#date_filter_wrapper input[type=checkbox]').click(function () {
                    let checked = $(this).is(':checked');
                    if (checked) {
                        $(this).addClass('selected-item');
                    } else {
                        $(this).removeClass('selected-item');
                    }
                })) ;
            }
        });
    } else {
        $('#content_previsu_cms_page .previsu_cms_page').attr('hide', 'false');
        $('#content_previsu_cms_page .previsu_cms_page').css('display', 'block');
    }

    // show x number of articles
    $('#content_previsu_cms_page .previsu_cms_page').hide();
    $('#content_previsu_cms_page .previsu_cms_page[hide=false]:lt(' + nbArticlesToShow + ')').show();

    let countShow = $('#content_previsu_cms_page .previsu_cms_page[hide=false]:visible').length;

    updateTotalElements(countShow, articlesToShowOnFilter);

    setTimeout(function () {
        let hideYear = true;

        $(elmt).parent().parent().parent().find("li").each(function (index) {
            if ($(this).find('input').hasClass('selected-item')) {
                hideYear = false;
            }
        });

        if (hideYear) {
            $(elmt).parent().parent().parent().find('input:checked').trigger('click');
        }
    }, 700);
}

// show x number of articles
function seeMoreArticles(elmt) {
    let id = $(elmt).attr('data-categ-id');
    let type = $(elmt).attr('data-type');
    let articlesToShowOnFilter = 0;
    let nbArticlesToShow = $(elmt).attr('data-articles-to-show');
    let checkedFilters = $('#date_filter_wrapper li ul input[type=checkbox][name="dates[]"]:checked');

    if (checkedFilters.length) {
        let count = 1;

        checkedFilters.each(function () {
            let value = $(this).val();

            $('#content_previsu_cms_page > .posts_' + value).each(function () {
                articlesToShowOnFilter++;

                if (!$(this).is(":visible") && (count <= nbArticlesToShow)) {
                    $(this).show();
                    count++;
                }
            });
        });
    } else {
        articlesToShowOnFilter = $("#content_previsu_cms_page .previsu_cms_page").length;
        $('#content_previsu_cms_page').find('.previsu_cms_page:not(:visible):lt(' + nbArticlesToShow + ')').show();
    }

    let previsuCmsPageVisible = $('#content_previsu_cms_page .previsu_cms_page:visible').length;
    let countPrevisuCmsPage = $('#content_previsu_cms_page .previsu_cms_page').length;

    if (countPrevisuCmsPage === previsuCmsPageVisible) {
        $(elmt).hide();
    }

    updateTotalElements(previsuCmsPageVisible, articlesToShowOnFilter);
}

// Filter articles
function filterArticles(element) {
    let checkedFilters = $('#date_filter_wrapper input[type=checkbox][name="dates[]"]:checked');

    if (checkedFilters.length) {
        checkedFilters.each(function () {
            let value = $(this).val();

            if (value.length == 7) {
                if ($('#date_filter_wrapper input[type=checkbox]').click(function () {
                    let checked = $(this).is(':checked');
                    if (checked) {
                        $(this).addClass('selected-item');
                    } else {
                        $(this).removeClass('selected-item');
                    }
                })) ;
            }
        });
    }
    let page = element.dataset.page;
    if (typeof page === "undefined") {
        page = 1;
    }
    getArticles(page);
}
var articles_xhr;
function getArticles(page)
{
    let form = $("#filterByDates");
    $("#page").val(page);
    let formData = form.serializeArray();

    if (articles_xhr) {
        articles_xhr.abort();
    }
    articles_xhr  = $.ajax({
        method: 'POST',
        data: formData,
        url: path_relative_root + 'ajax_get_cms_pages.html',
        success: function (res) {
            let translatedTextArticle = (res.nb_articles > 1) ? 'articles' : 'article';
            $('#nb_article').html(res.nb_articles + ' ' + Translator.translate(translatedTextArticle));

            $("#content_previsu_cms_page").html(res.content.articles);
            $("#cms_pagination").html(res.content.pagination);
            $("#cms_subcategory_menu .cms_menu_item.filter").removeClass("open");
        }
    });
}

// DATALAYER FUNCTION
function addToCart(rank) {
}

function removeFromCart(rank) {
}

/**
 * Function to resize words that are too long to fit in CMS cover-module
 *
 * @param {string} container - Selector for the container holding the text to resize.
 * @param {number} minimumFontSize - Minimum allowable font size, in pixels.
 * @param {number} maximumFontSizeInVW - Maximum allowable font size, in viewport width (vw).
 * @param {number} maximumFontSizeUltraWideScreen - Maximum allowable font size, in pixels for screens over 1920px.
 */
function cmsAutoFontResize(container, minimumFontSize, maximumFontSizeInVW, maximumFontSizeUltraWideScreen) {
    $(container).each(function () {
        const $container = $(this);
        const $title = $container.find('.cms-module-title');
        const $titleSpan = $title.find('span');
        
        // Get the initial container width and calculate maximum font size in px
        const containerWidth = $container.width() - 30; // Adjusting for padding
        const viewportWidth = $(window).width(); // Get the viewport width
        let maximumFontSize = (maximumFontSizeInVW / 100) * viewportWidth;
        
        // Limit font-size in px for screens wider than 1920px
        if (viewportWidth > 1920) {
            maximumFontSize = maximumFontSizeUltraWideScreen;
        }

        let fontSize = parseFloat($title.css('font-size'));
        let titleWidth = $titleSpan.width(); // Initial width of the title span

        // Check if the title span width exceeds the container width (shrink case)
        while (titleWidth > containerWidth && fontSize > minimumFontSize) {
            fontSize -= 1;  // Decrease font size in px
            fontSize = Math.round(fontSize);  // Round the font size to the nearest whole number
            $title.css('font-size', `${fontSize}px`);  // Set font size in px
            titleWidth = $titleSpan.width();  // Recalculate title span width
        }

        // Check if the title span width is less than the container width (expand case)
        while (titleWidth < containerWidth && fontSize < maximumFontSize) {
            fontSize += 1;  // Increase font size in px
            fontSize = Math.round(fontSize);  // Round the font size to the nearest whole number

            if (fontSize > maximumFontSize) {
                fontSize = maximumFontSize;  // Ensure the font size doesn't exceed maximum
            }

            $title.css('font-size', `${fontSize}px`);  // Set font size in px
            titleWidth = $titleSpan.width();  // Recalculate title span width
        }
    });
}

$(document).ready(function () { 
    // Iterate over each block
    $(".blocChoosePm").each(function () {
        let eachblocChoosePmItem = $(this);
        let textContainer = eachblocChoosePmItem.find(".blocblocChoosePmTitle p");
        let fullHtml = textContainer.html();  // Save original HTML
        let fullText = textContainer.text();  // Get plain text for counting

        // Check if the parent .whyChoosePm has the 'bloc_mobile' class
        let isMobile = eachblocChoosePmItem.closest(".whyChoosePm").hasClass("bloc_mobile");

        // Set character limit depending on mobile or desktop
        let limit = isMobile ? 200 : 310;

        if (fullText.length > limit) {

            // Function to crop HTML while counting only visible text
            function cropHtml(el, maxChars) {
                let count = 0;
                let result = "";

                el.contents().each(function () {
                    if (count >= maxChars) return;

                    if (this.nodeType === Node.TEXT_NODE) {
                        // Text node: truncate if exceeds limit
                        let text = this.nodeValue;
                        if (count + text.length > maxChars) {
                            result += text.substring(0, maxChars - count) + "...";
                            count = maxChars;
                        } else {
                            result += text;
                            count += text.length;
                        }
                    } else if (this.nodeType === Node.ELEMENT_NODE) {
                        // Element node: recursively crop child elements
                        let inner = cropHtml($(this), maxChars - count);
                        let clone = $(this).clone().empty().html(inner);
                        result += $("<div>").append(clone).html();
                        count += $(this).text().length;
                    }
                });

                return result;
            }

            // Crop the content while preserving HTML tags
            let croppedHtml = cropHtml(textContainer, limit);
            textContainer.html(croppedHtml);

            // Show the "Read more" button
            let btn = eachblocChoosePmItem.find(".show_more");
            btn.removeClass("hide");

            // Toggle full/cropped content on button click
            btn.on("click", function () {
                if (textContainer.hasClass("expanded")) {
                    // Collapse back to cropped version
                    textContainer.html(croppedHtml);
                    textContainer.removeClass("expanded");
                    $(this).text(Translator.translate('read_more'));
                } else {
                    // Expand to full HTML content
                    textContainer.html(fullHtml);
                    textContainer.addClass("expanded");
                    $(this).text(Translator.translate('read_less'));
                }
            });
        }
    });

    $(document).on('click', '#cms_page_btn_back .itm_back_btn', handleCmsBack);
});

// Objectif: éviter les mouseenter/mouseleave trop "nerveux" sur header/menu/icônes

function headerListeners() {
    const body = document.querySelector("body");
    let header = document.querySelector("header");
    const is_mobile = body.classList.contains("mobile");

    // -----------------------------
    // Helpers
    // -----------------------------

    // Throttle any function to 1 call per frame
    function rafThrottle(fn) {
        let rafId = 0;
        let lastArgs = null;

        return function throttled(...args) {
            lastArgs = args;
            if (rafId) return;
            rafId = requestAnimationFrame(() => {
                rafId = 0;
                fn.apply(this, lastArgs);
            });
        };
    }

    // Hover intent: apply only if pointer stays a bit (prevents "tempestive" enter)
    function createHoverIntent({
        enterDelay = 60,
        leaveDelay = 40,
        onEnter,
        onLeave,
    }) {
        let enterT = 0;
        let leaveT = 0;
        let inside = false;

        const cancelEnter = () => {
            if (enterT) clearTimeout(enterT);
            enterT = 0;
        };
        const cancelLeave = () => {
            if (leaveT) clearTimeout(leaveT);
            leaveT = 0;
        };

        const scheduleEnter = () => {
            cancelLeave();
            cancelEnter();
            enterT = setTimeout(() => {
                enterT = 0;
                if (!inside) return;
                onEnter && onEnter();
            }, enterDelay);
        };

        const scheduleLeave = () => {
            cancelEnter();
            cancelLeave();
            leaveT = setTimeout(() => {
                leaveT = 0;
                if (inside) return;
                onLeave && onLeave();
            }, leaveDelay);
        };

        return {
            pointerEnter() {
                inside = true;
                scheduleEnter();
            },
            pointerLeave() {
                inside = false;
                scheduleLeave();
            },
            cancel() {
                cancelEnter();
                cancelLeave();
            },
        };
    }

    function isModalOpen() {
        return !!document.querySelector(".modal[modal-open]");
    }

    // -----------------------------
    // Scroll listener (raf-throttled)
    // -----------------------------
    function scrollListener() {
        if (window.scrollY > 1) {
            if (header.hasAttribute("customization-transparent-state")) {
                header.removeAttribute("customization-transparent-state");
            }
            header.removeAttribute("customization-initial-state");
            header.setAttribute("customization-scroll-state", "");
        } else {
            if (body.classList.contains("homepage")) {
                header.setAttribute("customization-transparent-state", "");
            } else {
                header.setAttribute("customization-initial-state", "");
            }
            header.removeAttribute("customization-scroll-state");
        }

        // scroll direction tracking
        if (window.scrollY > 20 && window.scrollY > (window.lastScrollY || 0)) {
            body.setAttribute("scrolled-down", "");
        } else {
            body.removeAttribute("scrolled-down");
        }
        window.lastScrollY = window.scrollY;

        if (window.scrollY > 20) {
            body.setAttribute("hidden-pre-header", "");
        } else {
            body.removeAttribute("hidden-pre-header");
        }
    }

    const onScroll = rafThrottle(scrollListener);
    scrollListener(); // initial
    window.addEventListener("scroll", onScroll, { passive: true });

    // On mobile, load-partials.js reloads #site_head (which contains <header>) via
    // an ajax "Partial" once account/cart data is fetched, replacing the header node
    // captured above. Re-grab it and re-apply the current scroll state so the new
    // node doesn't stay stuck on whatever attributes its fresh markup was rendered with.
    window.addEventListener("accountLoad_complete", () => {
        header = document.querySelector("header");
        scrollListener();
    });

    // -----------------------------
    // Header hover intent (desktop)
    // -----------------------------
    const headerHover = createHoverIntent({
        enterDelay: 0,
        leaveDelay: 60,
        onEnter: rafThrottle(() => {
            if (is_mobile) return;

            if (header.hasAttribute("customization-initial-state")) {
                header.removeAttribute("customization-initial-state");
            } else if (header.hasAttribute("customization-transparent-state")) {
                header.removeAttribute("customization-transparent-state");
            }
            header.setAttribute("customization-hover-state", "");
        }),
        onLeave: rafThrottle(() => {
            if (is_mobile) return;
            if (header.hasAttribute("menu-open")) return;

            header.removeAttribute("customization-hover-state");

            if (!header.hasAttribute("customization-scroll-state")) {
                if (body.classList.contains("homepage") && window.scrollY <= 1) {
                    header.setAttribute("customization-transparent-state", "");
                } else {
                    header.setAttribute("customization-initial-state", "");
                }
            }
        }),
    });

    header.addEventListener("mouseenter", () => headerHover.pointerEnter());
    header.addEventListener("mouseleave", () => headerHover.pointerLeave());

    // Check if mouse is already in header on load
    const checkInitialMousePosition = (e) => {
        if (!is_mobile && header) {
            const rect = header.getBoundingClientRect();
            if (e.clientX >= rect.left && e.clientX <= rect.right &&
                e.clientY >= rect.top && e.clientY <= rect.bottom) {
                headerHover.pointerEnter();
            }
        }
    };

    // Listen for first mousemove to detect initial position
    document.addEventListener("mousemove", function initialMouseCheck(e) {
        checkInitialMousePosition(e);
        document.removeEventListener("mousemove", initialMouseCheck);
    }, { once: true, passive: true });
}

document.addEventListener("DOMContentLoaded", () => {
    headerListeners();
});

function lazyLoadSwiperImages(arg) {
    var swiper = arg && arg.slides ? arg : this;

    if (!swiper || !swiper.slides) {
        return;
    }

    var slidesVisible = 1;

    if (swiper.params && swiper.params.slidesPerView === 'auto') {
        if (swiper.size && swiper.slides[0] && swiper.slides[0].offsetWidth) {
            slidesVisible = Math.ceil(swiper.size / swiper.slides[0].offsetWidth);
        } else {
            slidesVisible = swiper.slides.length;
        }
    } else if (swiper.params && typeof swiper.params.slidesPerView === 'number') {
        slidesVisible = Math.ceil(swiper.params.slidesPerView);
    }

    var indicesToLoad = [];
    var startIndex = swiper.activeIndex - 1;
    var endIndex = swiper.activeIndex + slidesVisible;

    for (var i = startIndex; i <= endIndex + 1; i++) {
        indicesToLoad.push(i);
    }

    indicesToLoad.forEach(function (index) {
        var slide = swiper.slides[index];
        if (slide) {
            var $images = $(slide).find('img[data-src]');

            $images.each(function () {
                var $img = $(this);
                var srcATraiter = $img.attr('data-src');
                $img.attr('src', srcATraiter).removeAttr('data-src');
            });
        }
    });
}

function handleCmsBack(event) {
    event.preventDefault();

    var hasInternalHistory = false;

    if (window.history.length > 1 && document.referrer) {
        try {
            hasInternalHistory = new URL(document.referrer).origin === window.location.origin;
        } catch (error) {
            hasInternalHistory = false;
        }
    }

    if (hasInternalHistory) {
        window.history.back();
        return;
    }

    var cmsUrlBack = event.currentTarget.getAttribute('data-cms-url-back');
    var parentUrl = event.currentTarget.getAttribute('data-cms-parent-url');
    var homeUrl = typeof path_relative_root !== 'undefined' && path_relative_root
        ? path_relative_root
        : '/';

    window.location.assign(cmsUrlBack || parentUrl || homeUrl);
}